import { render, staticRenderFns } from "./ProjectProvisioningFileDownloadButton.vue?vue&type=template&id=ebe60ba8"
import script from "./ProjectProvisioningFileDownloadButton.vue?vue&type=script&lang=js"
export * from "./ProjectProvisioningFileDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports